import angular from 'angular';
import moment from 'moment';

import templateUrl from './rogers-payout-report.component.html';
import { containsInvariant, allContainsInvariant } from '../../../../../core/services/filter-util';

export const RogersPayoutReportComponent = {
    controller: RogersPayoutReportController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        payoutReport: '<',
        hideDivisionPayouts: "<?",
        hideOfficePayouts: "<?",
        hideRepPayouts: "<?",
        changeAdjustmentAmount: "&onChangeAdjustmentAmount"
    }
};

function RogersPayoutReportController() {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.filters = {};
    vm.filteredPayoutReport;
    vm.pageSize = 10;
    vm.pageNumber = 1;
    vm.onChangeFilter = onChangeFilter;
    vm.onChangeAdjustmentAmount = onChangeAdjustmentAmount;
    vm.onChangePage = onChangePage;

    const totalTypes = ["", "Office", "Rep"]; // Prefix types for each different kind of class of total.
    const amountTypes = ["BaseAmount", "MultiplayAmount", "ContentAmount", "InnovageRogersAdjustmentAmount", "TotalAmount"];
    const aggregateTotalTemplate = createAggregateTotalTemplate();

    function onInit() {
    }

    function onChanges() {
        filterPayoutReport();
        if (vm.pageSize * (vm.pageNumber - 1) > vm.filteredPayoutReport.length) {
            vm.pageNumber = 1;
        }
        calculateTotals();
    }

    function onChangeFilter() {
        filterPayoutReport();
        calculateTotals();
    }

    function createAggregateTotalTemplate() {
        // Create base totals for each class of total (base, office, rep) and each class of amount.
        return totalTypes.reduce(function (totals, prefix) {
            amountTypes.forEach(function (suffix) {
                totals[prefix + suffix] = 0;
            });
            return totals;
        }, {});
    }

    function filterPayoutReport() {
        vm.filteredPayoutReport = vm.payoutReport.filter(function (payout) {
            let employeeNameSearch = "";
            if (payout.Employee) {
                employeeNameSearch = payout.Employee.FirstName + " " + payout.Employee.LastName;
            }
            return allContainsInvariant(payout, vm.filters, [
                "SgiID",
                "AccountNumber",
                "CustomerFirstName",
                "CustomerLastName",
                "Address",
                "ProductCode",
                "ProductDescription",
                "TypeOfPayout",
                "Address",
                "WorkOrderNumber",
                "OwnerName"
            ])
                && (!vm.filters.EmployeeName || containsInvariant(employeeNameSearch, vm.filters.EmployeeName))
                && (!vm.filters.OrderDate || moment(vm.filters.OrderDate).isSame(payout.OrderDate))
                && (!vm.filters.InstalledDate || moment(vm.filters.InstalledDate).isSame(payout.ConfirmedDate))
                && (!vm.filters.AppointmentDate || moment(vm.filters.AppointmentDate).isSame(payout.AppointmentDate))
                && (!vm.filters.CancelledDate || moment(vm.filters.CancelledDate).isSame(payout.CancelledDate))
                && (!vm.filters.DisconnectedDate || moment(vm.filters.DisconnectedDate).isSame(payout.DisconnectedDate))
                && (!vm.filters.ProductLine || containsInvariant(
                    payout.ProductLineName, vm.filters.ProductLine))
                && (!vm.filters.WorkOrderNumber || containsInvariant(
                    payout.WorkOrderNumber, vm.filters.WorkOrderNumber));

        }).sort(sortPayoutReport);
        vm.pageNumber = Math.min(vm.pageNumber, Math.ceil(vm.filteredPayoutReport.length / vm.pageSize));
        // Data on an individual page can be edited, so create a mutable copy of the data.
        vm.payoutReportPage = vm.filteredPayoutReport.slice((vm.pageNumber - 1) * vm.pageSize,
            vm.pageNumber * vm.pageSize)
            .reduce((payouts, payout) => {
                const payoutVM = {};
                for (const field of Object.keys(payout)) {
                    if (field.indexOf("_") !== 0) {
                        // Exclude private fields starting with an underscore.
                        payoutVM[field] = payout[field];
                    }
                }
                payouts.push(payoutVM);
                return payouts;
            }, []);
    }

    function onChangePage() {
        // Data on an individual page can be edited, so create a mutable copy of the data.
        vm.payoutReportPage = angular.copy(vm.filteredPayoutReport.slice((vm.pageNumber - 1) * vm.pageSize,
            vm.pageNumber * vm.pageSize));
    }

    function calculateTotals() {
        vm.payoutReportTotals = totalTypes.reduce(function (totals, prefix) {
            amountTypes.forEach(function (suffix) {
                vm.filteredPayoutReport.forEach(function (payout) {
                    totals[prefix + suffix] += payout[prefix + suffix];
                });
            });
            return totals;
        }, angular.copy(aggregateTotalTemplate));
    }

    function onChangeAdjustmentAmount(payout) {
        vm.changeAdjustmentAmount({ $event: { payout: payout } });
        // The mutated payout is a clone. Update the "real" payout passed to the view as well.
        const index = vm.payoutReport.findIndex(item => item.ProductOrderID === payout.ProductOrderID);
        if (index >= 0) {
            vm.payoutReport[index].IsAdjustmentAmountModified = true;
            vm.payoutReport[index].InnovageRogersAdjustmentAmount = payout.InnovageRogersAdjustmentAmount;
        }
    }

    function sortPayoutReport(a, b) {
        if (a.OrderDate > b.OrderDate) {
            return -1;
        } else if (a.OrderDate < b.OrderDate) {
            return 1;
        }
        if (a.OwnerName < b.OwnerName) {
            return -1;
        } else if (a.OwnerName > b.OwnerName) {
            return 1;
        }
        if (a.ClientName < b.ClientName) {
            return -1;
        } else if (a.ClientName > b.ClientName) {
            return 1;
        }
        if (!a.Employee && b.Employee) {
            return -1;
        } else if (a.Employee && !b.Employee) {
            return 1;
        } else if (a.Employee || b.Employee) {
            // Sort conditionally based on if there is an employee.
            if (a.Employee.FirstName < b.Employee.FirstName) {
                return -1;
            } else if (a.Employee.FirstName > b.Employee.FirstName) {
                return 1;
            }
            if (a.Employee.LastName < b.Employee.LastName) {
                return -1;
            } else if (a.Employee.LastName > b.Employee.LastName) {
                return 1;
            }
        }
        return 0;
    }
}
